import { createFileRoute } from '@tanstack/react-router';

import { ManagerCommandCenter } from '../../features/manager-command-center/components/ManagerCommandCenter';

export const Route = createFileRoute('/_onboarding/command-center')({
  component: CommandCenterRoute,
});

function CommandCenterRoute() {
  return <ManagerCommandCenter />;
}
